// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CertificationEnrolmentQueryVariables = PrivateSchemaTypes.Exact<{
  certificationId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CertificationEnrolmentQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'id' | 'display_name' | 'first_name' | 'last_name' | 'email'>
    & { certificationEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CertificationEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.CertificationEnrolmentModelAsStudent, 'id' | 'progress' | 'completed_at' | 'target_date' | 'expires_at' | 'status'>
      & { certification: (
        { __typename?: 'CertificationModelAsStudent' }
        & Pick<PrivateSchemaTypes.CertificationModelAsStudent, 'id' | 'name' | 'description' | 'template_id' | 'months_of_validity'>
        & { certificateTemplate?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CertificateTemplateModel' }
          & Pick<PrivateSchemaTypes.CertificateTemplateModel, 'id' | 'svg' | 'orientation'>
        )>, author?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
        )>, organisation: (
          { __typename?: 'OrganisationModelGQLBase' }
          & Pick<PrivateSchemaTypes.OrganisationModelGqlBase, 'id' | 'name'>
        ), items: Array<(
          { __typename?: 'CertificationItemModel' }
          & Pick<PrivateSchemaTypes.CertificationItemModel, 'id' | 'item_id' | 'item_type' | 'order'>
          & { pathway?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'PathwayModelAsStudent' }
            & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'title' | 'numberOfTopics'>
            & { currentEnrolment?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'PathwayEnrolmentModelAsStudent' }
              & Pick<PrivateSchemaTypes.PathwayEnrolmentModelAsStudent, 'id' | 'isCompleted' | 'progress' | 'status' | 'completed_status'>
            )> }
          )>, topic?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'TopicModelAsMember' }
            & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'currentTitle'>
            & { lastEnrolment?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'TopicEnrolmentModelAsStudent' }
              & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'completion_date' | 'isCompleted' | 'status' | 'available_points' | 'auto_correct' | 'isMaxAttemptsExceeded' | 'pass_mark'>
              & { topicVersion?: PrivateSchemaTypes.Maybe<(
                { __typename?: 'TopicVersionModel' }
                & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'allow_retry'>
              )> }
            )> }
          )>, event?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'EventModelAsStudent' }
            & Pick<PrivateSchemaTypes.EventModelAsStudent, 'id' | 'title' | 'start_time' | 'end_time'>
            & { currentUserInvitation?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'UserEventModel' }
              & Pick<PrivateSchemaTypes.UserEventModel, 'present'>
            )> }
          )> }
        )> }
      ) }
    )> }
  ) }
);


export const CertificationEnrolmentDocument = gql`
    query certificationEnrolment($certificationId: PositiveInt!) {
  me {
    id
    display_name
    first_name
    last_name
    email
    certificationEnrolment(certificationId: $certificationId) {
      id
      progress
      completed_at
      target_date
      expires_at
      status
      certification {
        id
        name
        description
        template_id
        certificateTemplate {
          id
          svg
          orientation
        }
        months_of_validity
        author {
          id
          display_name
        }
        organisation {
          id
          name
        }
        items {
          id
          item_id
          item_type
          pathway {
            id
            title
            numberOfTopics
            currentEnrolment {
              id
              isCompleted
              progress
              status
              completed_status
            }
          }
          topic {
            id
            currentTitle
            lastEnrolment {
              topicVersion {
                id
                allow_retry
              }
              completion_date
              isCompleted
              status
              available_points
              auto_correct
              isMaxAttemptsExceeded
              pass_mark
            }
          }
          event {
            id
            title
            start_time
            end_time
            currentUserInvitation {
              present
            }
          }
          order
        }
      }
    }
  }
}
    `;

/**
 * __useCertificationEnrolmentQuery__
 *
 * To run a query within a React component, call `useCertificationEnrolmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificationEnrolmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificationEnrolmentQuery({
 *   variables: {
 *      certificationId: // value for 'certificationId'
 *   },
 * });
 */
export function useCertificationEnrolmentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CertificationEnrolmentQuery, CertificationEnrolmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CertificationEnrolmentQuery, CertificationEnrolmentQueryVariables>(CertificationEnrolmentDocument, options);
      }
export function useCertificationEnrolmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CertificationEnrolmentQuery, CertificationEnrolmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CertificationEnrolmentQuery, CertificationEnrolmentQueryVariables>(CertificationEnrolmentDocument, options);
        }
export type CertificationEnrolmentQueryHookResult = ReturnType<typeof useCertificationEnrolmentQuery>;
export type CertificationEnrolmentLazyQueryHookResult = ReturnType<typeof useCertificationEnrolmentLazyQuery>;
export type CertificationEnrolmentQueryResult = Apollo.QueryResult<CertificationEnrolmentQuery, CertificationEnrolmentQueryVariables>;